import axios from 'axios'
import LoginForm from '../../components/admin/LoginForm'
import { useState, useEffect } from 'react'
import '../../static/css/Admin.css'
import AdminHome from './AdminHome'
import { TOKEN_KEY } from '../../services/auth'

export default function Admin({ status_code }) {
    const [adminToken, setAdminToken] = useState(null)
    const [status, setStatus] = useState('')
    const [isAuthenticated, setIsAuthenticated] = useState('')

    console.log(process.env)
    
    return (<>
        <main className='fixed w-screen h-screen bg-slate-700 overflow-y-scroll'>
            {isAuthenticated === 'authenticated' ? (
                <AdminHome setIsAuthenticated={setIsAuthenticated} />
            ): (
                <LoginForm setIsAuthenticated={setIsAuthenticated} />
            )}
        </main>
    </>)

}